module.exports = __webpack_public_path__ + "img/12_responsible_consumption_and_production_color.f58ebf80.svg";